module.exports = __webpack_public_path__ + "last.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/last.svg?color1=%23333333&color2=
// module id = 914
// module chunks = 67